import React, { useContext, useEffect, useState } from "react";
import SimpleBackdrop from "../../components/loader/backdrop";
import CallToAction from "./partials/cta";
import ErrorMessage from "./partials/error";
import FieldLabel from "../../components/common/label";
import TermsAndCondition from "../../components/common/termsAndCondition";
import ApplicatonContext from "../../context/index";
import EstimationDetailsForm from "./partials/estimation";
import DepreciationSlab from "./partials/depreciationSlab";
import CircularProgress from "@material-ui/core/CircularProgress";
import withStyles from "@material-ui/core/styles/withStyles";
import { Help } from "@material-ui/icons";
import { Box, Typography } from "@material-ui/core";
import {
  BUTTON_PAY,
  BUTTON_SUBMIT,
  NOTE_CLAIM_PROCESSING_CHARGE,
  TERMS_AND_CONDITION,
  TOOLTIP_CLAIM_PROCESSING_CHARGE,
} from "../../constants/index";
import {
  isCopaymentRequired,
  isLoginViaMasterOtp,
  isLoginViaMasterOtpUser,
  isSubmitButtonDisabled,
  syncProposalDetails,
} from "../../helpers/proposal";
import { useStyles } from "./indexFormStyles";
import { getWebService } from "../../helpers/server";

function ProposalForm({
  classes: { container, estimateContainer, loaderBox, main, tndc },
  changeOptionBaseOnValue,
  claim,
  errorMessage,
  errors,
  form,
  handleAutocompleteChange,
  handleChange,
  handleChangeChipSelect,
  isManufacturerChanged,
  isManufacturerVisible,
  isModelChanged,
  isModelVisible,
  isVariantVisible,
  isFormSubmitted,
  setIsServiceCentreFormSubmitted,
  isSearchCompleted = true,
  onSubmit,
  setForm,
  photo,
  photoChangeHandler,
}) {
  const {
    state: { orderDetails = null },
  } = useContext(ApplicatonContext);

  const [modal, setModal] = useState({ staticPage: false });
  const [content, setContent] = useState({ body: null });

  const onTerms = async (url) => {
    window.open(url, "_blank");
    // try {
    //   const response = await getWebService("term-and-conditions");
    //   const {
    //     data: { content: body },
    //   } = response.data;

    //   setContent({
    //     ...content,
    //     body,
    //   });
    //   toggleModal("staticPage", true);
    // } catch (error) {}
  };

  const clickButton = (event, value) => {
    event.type = value === 2 ? 'service_centre_pay_now' : event.type;
    onSubmit(event);
  };

  const toggleModal = (key = "staticPage", value = true) => {
    setModal({
      ...modal,
      [key]: value,
    });
  };

  useEffect(() => {
    setForm({
      ...form,
      ...syncProposalDetails(orderDetails ? orderDetails : {}),
    });
  }, [orderDetails]);

  return (
    <>
      <Box className={main}>
        <Box container={"true"} justifyContent="center" className={container}>
          {claim ? (
            <Box className={loaderBox}>
              <CircularProgress color={"secondary"} />
            </Box>
          ) : (
            <form noValidate autoComplete="off">
              {orderDetails && (
                <Box className={estimateContainer} m={2} p={2}>
                  <EstimationDetailsForm
                    changeOptionBaseOnValue={changeOptionBaseOnValue}
                    errorMessage={errorMessage}
                    form={form}
                    handleAutocompleteChange={handleAutocompleteChange}
                    handleChange={handleChange}
                    handleChangeChipSelect={handleChangeChipSelect}
                    photoChangeHandler={photoChangeHandler}
                    isManufacturerChanged={isManufacturerChanged}
                    isManufacturerVisible={isManufacturerVisible}
                    isModelChanged={isModelChanged}
                    isModelVisible={isModelVisible}
                    isVariantVisible={isVariantVisible}
                    isSearchCompleted={isSearchCompleted}
                  />
                </Box>
              )}

              <ErrorMessage errors={errors} />

              {orderDetails && 1 === 2 && (
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  data-tip={TOOLTIP_CLAIM_PROCESSING_CHARGE}
                >
                  <Typography variant="subtitle2">
                    Claim Processing Charges&nbsp;
                  </Typography>
                  <Help />
                </Box>
              )}

              {orderDetails && orderDetails.product_name === 'Complete Damage Protection' && <DepreciationSlab />}

              {orderDetails &&
                isCopaymentRequired(orderDetails?.product_id) && (
                  <div
                    style={{
                      display: "flexs",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "10px",
                      flexWrap: "wrap",
                    }}
                  >
                    <Box>
                      <FieldLabel
                        label={`Please pay processing fee ₹${orderDetails?.copayment_amount}. This amount will be refunded if the claim is rejected. Please refer your plan`}
                        fieldValue={""}
                        required={false}
                        labelKey={"copayment_note"}
                      />
                    </Box>
                    <Box
                      onClick={() =>
                        onTerms(
                          "https://dvt.tnl.mybluehostin.me/terms-conditions/"
                        )
                      }
                    >
                      <FieldLabel
                        variant="body1"
                        label={TERMS_AND_CONDITION}
                        fieldValue={""}
                        required={false}
                        labelKey={"copayment_note"}
                        customClass={tndc}
                      />
                    </Box>
                  </div>
                )}
              {console.log(
                " orderDetails?.copayment_amount",
                orderDetails?.copayment_amount
              )}

              {orderDetails && (
                <CallToAction
                  buttonType={"submit"}
                  errorMessage={errorMessage}
                  form={form}
                  isDisabled={isSubmitButtonDisabled(
                    form,
                    errorMessage,
                    orderDetails,
                    photo,
                    isFormSubmitted
                  )}
                  handleClick={(e) => clickButton(e, 1)}
                  isFormSubmitted={isFormSubmitted}
                  text={
                    isCopaymentRequired(orderDetails?.product_id)
                      ? isLoginViaMasterOtp()
                        ? `Send Payment Link of ₹${Number(
                            orderDetails?.copayment_amount
                          ).toLocaleString("en")}`
                        : `${BUTTON_PAY}${Number(
                            orderDetails?.copayment_amount
                          ).toLocaleString("en")}`
                      : BUTTON_SUBMIT
                  }
                />
              )}

              {orderDetails && isLoginViaMasterOtpUser() && (
                <CallToAction
                  buttonType={"pay_now_submit"}
                  errorMessage={errorMessage}
                  form={form}
                  isDisabled={isSubmitButtonDisabled(
                    form,
                    errorMessage,
                    orderDetails,
                    photo,
                    setIsServiceCentreFormSubmitted
                  )}
                  handleClick={(e) => clickButton(e, 2)}
                  isFormSubmitted={setIsServiceCentreFormSubmitted}
                  text={
                    isCopaymentRequired(orderDetails?.product_id)
                      ? `Pay Now ₹${Number(
                          orderDetails?.copayment_amount
                        ).toLocaleString("en")}`
                      : BUTTON_SUBMIT
                  }
                />
              )}
            </form>
          )}

          {(!isSearchCompleted || isFormSubmitted || setIsServiceCentreFormSubmitted) && <SimpleBackdrop />}
        </Box>
      </Box>

      <TermsAndCondition
        state={modal.staticPage}
        onclick={() => toggleModal("staticPage", false)}
        body={content?.body}
      />
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(ProposalForm);
